var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import colors from '../../colors';
import Typography from '../Typography';
import { IconByName } from '../../utils/IconByName';
var borderRadius = '50px';
var buttonProps = {
    default: {
        color: colors.grey[700],
        backgroundColor: 'transparent',
        hoverColor: colors.grey[900],
    },
    selected: {
        color: colors.blue[500],
        backgroundColor: colors.blue[100],
        hoverColor: colors.blue[600],
    },
    disabled: {
        color: colors.grey[300],
        backgroundColor: 'transparent',
        hoverColor: colors.grey[300],
    },
};
var StyledToggleButtonGroup = styled(ToggleButtonGroup)({
    '& .MuiToggleButtonGroup-grouped': {
        margin: '4px',
        border: 0,
        '&.Mui-disabled': {
            border: 0,
        },
        borderRadius: borderRadius,
        '&:not(:first-of-type)': {
            borderRadius: borderRadius,
        },
        '&:first-of-type': {
            borderRadius: borderRadius,
        },
    },
});
var StyledToggleButton = styled(ToggleButton)(function () { return ({
    borderRadius: '50px',
    display: 'flex',
    gap: '4px',
    color: buttonProps.default.color,
    backgroundColor: buttonProps.default.backgroundColor,
    '&:hover': {
        color: buttonProps.default.hoverColor,
        backgroundColor: buttonProps.default.backgroundColor,
    },
    '&.Mui-selected': {
        color: buttonProps.selected.color,
        backgroundColor: buttonProps.selected.backgroundColor,
        '&:hover': {
            color: buttonProps.selected.hoverColor,
            backgroundColor: buttonProps.selected.backgroundColor,
        },
    },
    '&.Mui-disabled': {
        color: buttonProps.disabled.hoverColor,
    },
    '&.MuiToggleButton-sizeSmall': {
        height: '24px',
        padding: '0 12px',
    },
    '&.MuiToggleButton-sizeMedium': {
        height: '32px',
        padding: '0 16px',
    },
}); });
var ToggleGroup = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, defaultValue = _a.defaultValue, _b = _a.size, size = _b === void 0 ? 'small' : _b, fullWidth = _a.fullWidth, componentDisabled = _a.disabled;
    var _c = useState(defaultValue), currentValue = _c[0], setCurrentValue = _c[1];
    var _value = value === undefined ? currentValue : value;
    var getIconColor = function (selected, disabled) {
        if (componentDisabled || disabled) {
            return buttonProps.disabled.color;
        }
        return selected ? buttonProps.selected.color : buttonProps.default.color;
    };
    return (_jsx(Box, __assign({ sx: {
            display: 'flex',
            border: "1px solid ".concat(colors.grey[300]),
            backgroundColor: colors.white,
            flexWrap: 'wrap',
            width: fullWidth ? '100%' : 'fit-content',
            '&.toggle-group-sizeSmall': {
                borderRadius: '16px',
            },
            '&.toggle-group-sizeMedium': {
                borderRadius: '24px',
            },
        }, className: size === 'small' ? 'toggle-group-sizeSmall' : 'toggle-group-sizeMedium', "data-testid": "sweep-toggle-group" }, { children: _jsx(StyledToggleButtonGroup, __assign({ size: size, value: _value, exclusive: true, onChange: function (e, __value) {
                if (__value === null)
                    return; // Disable unselecting
                value === undefined && setCurrentValue(__value);
                onChange && onChange(__value);
            }, fullWidth: fullWidth }, { children: options.map(function (option) { return (_jsxs(StyledToggleButton, __assign({ value: option.value, disabled: componentDisabled || option.disabled }, { children: [option.startIconName && (_jsx(IconByName, { name: option.startIconName, color: getIconColor(option.value === _value, option.disabled) })), _jsx(Typography, __assign({ variant: size === 'small' ? 'caption' : 'body' }, { children: option.label }))] }), option.value)); }) })) })));
};
export default ToggleGroup;
